import { Expose, Type } from "class-transformer";
import { IsOptional, IsBoolean, IsString, ValidateNested, IsNumber } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class PrinterCommand {
  @IsString()
  @Expose()
  id!: string; //GUID

  @Expose()
  @IsString()
  @IsOptional()
  createdAt!: string | null;
  @Expose()
  @IsString()
  @IsOptional()
  commandTime!: string | null;
  @Expose()
  @IsString()
  @IsOptional()
  documentNumber!: string | null;
  @Expose()
  @IsString()
  @IsOptional()
  userName!: string | null;
  @Expose()
  @IsString()
  @IsOptional()
  commandType!: string | null;
  @Expose()
  @IsNumber()
  @IsOptional()
  recordStampId!: number | null;
  @Expose()
  @IsString()
  @IsOptional()
  logType!: string | null;
  @Expose()
  @IsString()
  @IsOptional()
  message!: string | null;

  @Expose()
  @IsBoolean()
  sendAgain!: boolean;
}

export class PrinterCommandListResponse extends GenericTableResponse<PrinterCommand> {
  @Type(() => PrinterCommand)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<PrinterCommand>;
}
